import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { PagesHelper } from "../common/PagesHelper";
import AutocompleteSingle from "../components/library/AutocompleteSingle";
import { AuthUserPermissions, MenuItem, PageName,PageState,UserInfo,UserListResponseDto } from "../utils/types";
import { ResponseStatus } from "../utils/types";
import StateHelper from "../utils/StateHelper";
import { Col, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { camelCaseToTitleCase } from "../utils/misc";
import './CurrentUserBar.css';
import MenuIcon from '../assets/icons/menu.svg';
import { setDocumentTitle } from "../utils/documentTitle";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth0 } from "@auth0/auth0-react";
import { hasPermission } from "../utils/UserHelper";

interface CurrentUserBarProps {
  currentUser: UserInfo;
  activeLink: string;
  setActiveLink: (page: string) => void;
  onChange: (selected: any) => void;
  viewAsUserListDto: UserListResponseDto;
  envBgColor: string;
}

export default function CurrentUserBar(props : CurrentUserBarProps) : any {
  const { logout } = useAuth0();
  const currentUser =  props.currentUser;

  function onLogout() {
    logout({
      logoutParams: {
        returnTo: window.location.origin + "/"
      }
    });
  }

  function onPageChange(e: any, page:string) {
    if (!e.ctrlKey && !e.metaKey) {
      props.setActiveLink(page);
      setDocumentTitle(page, currentUser);
      const pageState : PageState = StateHelper.getPageState();
      pageState.page = page;
    }
  }

  const adminIcon = <FontAwesomeIcon icon={faLock} fixedWidth></FontAwesomeIcon>;

  if (currentUser == null) {
    return (<Form inline></Form>);
  } else {

    let viewAsObj = null;
    const pageState : PageState = StateHelper.getPageState();
    const viewAsUserId = pageState.viewAs;

    if (props.viewAsUserListDto) {
      if (props.viewAsUserListDto.status === ResponseStatus.ERROR) {
        viewAsObj = <Form.Control type="text" className="text-center" placeholder="Unable to load Users" size="sm" style={{borderColor : 'red', backgroundColor: 'gainsboro'}} readOnly />;
      }
      else {
        const userList = props.viewAsUserListDto.userListResponse ? props.viewAsUserListDto.userListResponse : []; 
        const labelKeyFunction = (user: any, obj : any, index : number) => {
          return user.name === user.email ? user.name : user.name + " (" + user.email + ")";
        }
        let selectedUsers : any[] =  [];
        if ( viewAsUserId != null && userList.length > 0 ){
          selectedUsers = userList.filter((item : any) => item.userId === viewAsUserId);
        }

        viewAsObj = <AutocompleteSingle
                      placeholder="View as User" id="viewAsUserCmb1"
                      labelKey={labelKeyFunction}
                      options={userList}
                      onChange={props.onChange}
                      selected={selectedUsers}
                      style={{ fontSize: 11, width: "250px" }}
                    />;
      }
    }

    // Build URLs for pages with state management (products and performanceStats)
    // These pages preserve filters when navigating between them
    const productsUrl = StateHelper.hasPageState(PageName.products)
      ? PagesHelper.getPageUrl(PageName.products, StateHelper.getPageState(PageName.products))
      : "/" + PageName.products + PagesHelper.getInitialPageUrl(PageName.products);

    const performanceStatsUrl = StateHelper.hasPageState(PageName.performanceStats)
      ? PagesHelper.getPageUrl(PageName.performanceStats, StateHelper.getPageState(PageName.performanceStats))
      : "/" + PageName.performanceStats + PagesHelper.getInitialPageUrl(PageName.performanceStats);

    // Other pages don't use StateHelper - just use initial defaults
    const trackingLinksLookupUrl = "/" + PageName.trackingLinksLookup + PagesHelper.getInitialPageUrl(PageName.trackingLinksLookup);
    const lookupUrl = "/" + PageName.lookup + PagesHelper.getInitialPageUrl(PageName.lookup);
    const liveLogsUrl = "/" + PageName.liveLogs + PagesHelper.getInitialPageUrl(PageName.liveLogs);
    const inventoryUrl = "/" + PageName.inventory + PagesHelper.getInitialPageUrl(PageName.inventory);
    const authUserUrl = "/" + PageName.authUser + PagesHelper.getInitialPageUrl(PageName.authUser);

    const plutoPartnersUrl = process.env.REACT_APP_PLUTO_BASE_URL + "/partners";
    const plutoCampaignsUrl = process.env.REACT_APP_PLUTO_BASE_URL + "/campaigns";

    let combinedMenu:Record<string, Record<string, MenuItem>|MenuItem> = {};

    // Reporting as a standalone menu item (not a dropdown)
    combinedMenu['Reporting'] = {link: productsUrl, page: PageName.products};

    // Performance as a standalone menu item (not a dropdown)
    combinedMenu['Performance'] = {link: performanceStatsUrl, page: PageName.performanceStats};

    combinedMenu['Campaigns'] = {};
    (combinedMenu['Campaigns'] as Record<string, MenuItem>)['Tracking Links Lookup'] = {link: trackingLinksLookupUrl, page: PageName.trackingLinksLookup};
    (combinedMenu['Campaigns'] as Record<string, MenuItem>)['Lookup'] = {link: lookupUrl, page: PageName.lookup};
    (combinedMenu['Campaigns'] as Record<string, MenuItem>)['Pluto - Partners'] = {link: plutoPartnersUrl};
    (combinedMenu['Campaigns'] as Record<string, MenuItem>)['Pluto - Campaigns'] = {link: plutoCampaignsUrl};

    combinedMenu['Inventory'] = {link: inventoryUrl, page: PageName.inventory};
    combinedMenu['Live Logs'] = {link: liveLogsUrl, page: PageName.liveLogs};

    if (hasPermission(AuthUserPermissions.userView)) {
      combinedMenu['Users'] = {link: authUserUrl, page: PageName.authUser, admin: true};
    }

    return (
      <>
        <Navbar className={"reporting-dashboard-navbar " + props.envBgColor} style={{ justifyContent: "space-", padding: 0, color: "white" }}>
          <Col xl={4} style={{ display: "flex", padding: 0 }}>
            <Nav.Link data-toggle="collapse" style={{ padding: "12px 24px", color: "white", backgroundColor: "#272C30", fontSize: "1rem" }} data-target="#navbar-container" aria-controls="navbarSupportedContent1">
              <img src={MenuIcon} style={{ width: "16px", height: "16px", verticalAlign: "text-bottom", marginRight: "5px" }} alt="menu" />
              {process.env.REACT_APP_NAME}
            </Nav.Link>
          </Col>
          <Col xl={4} style={{ display: "flex", justifyContent: "center", fontSize: "1rem" }}>
            {
              process.env.REACT_APP_BRANCH && <span>{process.env.REACT_APP_BRANCH}&nbsp;-&nbsp;</span>
            }
            <span>{camelCaseToTitleCase(props.activeLink)}</span>
          </Col>
          <Col xl={4} style={{ display: "flex", justifyContent: "right", padding: "0 9px" }}>
            <Nav.Link onClick={onLogout} style={{ display: "flex", alignItems: "center" }}>
              Sign out
              <img src={currentUser.picture} title={currentUser ? currentUser.email : ""} alt={currentUser ? currentUser.email : ""} style={currentUser.picture ? { maxHeight: "25px", maxWidth: "25px", paddingLeft: "5px" } : { paddingLeft: "5px" }} />
            </Nav.Link>
          </Col>
        </Navbar>

        <div id="navbar-container" className="reporting-dashboard-navbar bg-dark collapse show">
          <Navbar id="navbar" style={{ justifyContent: "space-between", backgroundColor: "#272C30" }}>
            <div className="d-flex align-items-center">
              {Object.keys(combinedMenu).map((menuKey) => {
                const menuItem = combinedMenu[menuKey] as MenuItem;

                // Direct button (MenuItem)
                if ('link' in menuItem && 'page' in menuItem) {
                  return (
                    <Nav.Link
                      as={Link}
                      key={menuKey}
                      to={menuItem.link}
                      disabled={menuItem.page === props.activeLink}
                      onClick={(e:any) => onPageChange(e, (menuItem as MenuItem).page)}
                    >
                      {menuKey} {menuItem.admin ? adminIcon : ""}
                    </Nav.Link>
                  );
                }

                // Dropdown (Record<string, MenuItem>)
                if (typeof menuItem === "object" && menuItem !== null && !("link" in menuItem && "page" in menuItem)) {
                  const submenu = menuItem as Record<string, MenuItem>;

                  return (
                    <NavDropdown key={menuKey} title={menuKey} id={menuKey}>
                      {Object.keys(submenu).map((title) => {
                        const menuItem = submenu[title];
                        return menuItem.page != null ? (
                          <NavDropdown.Item
                            to={menuItem.link}
                            as={Link}
                            key={title}
                            disabled={menuItem.page === props.activeLink}
                            onClick={(e) => onPageChange(e, menuItem.page)}
                          >
                            {title} {menuItem.admin ? adminIcon : ""}
                          </NavDropdown.Item>
                        ) : (
                          <a className="dropdown-item" href={menuItem.link} key={title}>
                            {title} {menuItem.admin ? adminIcon : ""}
                          </a>
                        );
                      })}
                    </NavDropdown>
                  );
                }
                return "";
              })}
            {pageState.viewAs && <Nav.Link disabled={true} style={{fontStyle: "italic"}}>&laquo;PMD menu unavailable with view-as&raquo;</Nav.Link> }
            
            </div>
            <Form className="d-flex align-items-center">
              {viewAsObj}
            </Form>
          </Navbar>
        </div>
      </>
    );
  }
}